{
  "greeting": "¡Hola! ¿Cómo puedo ayudarte con vinos hoy?",
  "thinking": "✨ Pensando...",
  "thinkingStep": "✨ Descorchando la combinación perfecta para ti…🍷",
  "askAboutWine": "Ej. Burdeos tinto de los 90 alrededor de $1500 | Borgoña blanco de pueblo menos de $600",
  "askAboutWineFirst": "Quiero comprar (región + color + añada + presupuesto)",
  "waitingForResponse": "Esperando respuesta...",
  "dailyLimitReached": "Has alcanzado el límite diario de consultas. Por favor vuelve después de las 00:00 HKT para continuar.",
  "chatHistory": "Tu historial de chat",
  "noChatHistory": "Aún no hay historial de chat",
  "startConversation": "Inicia una conversación para verla aquí",
  "backToChat": "Volver al chat",
  "newChat": "Nuevo chat",
  "history": "Historial",
  "search": "Buscar",
  "whatsapp": "WhatsApp",
  "wineAdvisor": "Asesor de vinos",
  "chat": "Chat",
  "chatNumber": "Chat {number}",
  "wineRecommended": "{count} vino recomendado",
  "winesRecommended": "{count} vinos recomendados",
  "justNow": "Ahora mismo",
  "minuteAgo": "Hace {count} minuto",
  "minutesAgo": "Hace {count} minutos",
  "hourAgo": "Hace {count} hora",
  "hoursAgo": "Hace {count} horas",
  "dayAgo": "Hace {count} día",
  "daysAgo": "Hace {count} días",
  "noMessagesYet": "Aún no hay mensajes",
  "perBottle": "Por botella",
  "priceNA": "Precio no disponible",
  "buyNow": "Comprar ahora",
  "moreInformation": "Más información",
  "share": {
    "button": "Compartir",
    "title": "Compartir conversación",
    "description": "Comparte esta conversación con tus amigos usando el enlace de abajo:",
    "generating": "Generando enlace para compartir...",
    "error": "Error al generar el enlace para compartir",
    "copy": "Copiar",
    "copied": "¡Copiado!",
    "note": "Nota: Este enlace expirará en 30 días. Cuando alguien abra este enlace, verá una copia de esta conversación."
  },
  "checkOutWine": "Echa un vistazo a este vino: {name} {vintage}",
  "linkCopied": "¡Enlace copiado al portapapeles!",
  "contactWhatsApp": "Contáctanos en WhatsApp para más opciones",
  "errorLoadingWine": "Lo siento, no pude cargar los detalles del vino.",
  "errorOccurred": "Ocurrió un error al obtener la respuesta.",
  "you": "Tú",
  "welcome": {
    "intro": "Bienvenido a WWX, soy Zyra, tu asesora de vinos con IA. Puedes acceder a:",
    "features": {
      "globalMarket": "Mercado global de vinos finos (vendedores UK, FR, HK)",
      "realTimeOffers": "Mejores ofertas en tiempo real dentro de tu presupuesto",
      "personalized": "Recomendaciones personalizadas solo para ti",
      "comparison": "Comparación fácil de añadas y marcas",
      "instantCheckout": "Cantidades y envío instantáneo"
    },
    "question": "¿Qué puedo recomendarte hoy?",
    "trendingPrompts": "Consultas de ejemplo",
    "promptExamples": {
      "title": "Cómo preguntar:",
      "good": "✓ Buenos ejemplos:",
      "bad": "✗ Evita consultas sin presupuesto:"
    },
    "prompts": {
      "bordeaux": "Burdeos tinto alrededor de $800",
      "champagne": "Champagne de productor menos de $2000",
      "firstGrowth": "Mejor oferta first growth 2010-2019"
    }
  },
  "feedback": {
    "helpful": "Esto fue útil",
    "notHelpful": "Esto no fue útil",
    "thankYou": "¡Gracias por tu opinión!",
    "whatDidYouLike": "¿Qué te gustó?",
    "whatCouldBeImproved": "¿Qué se podría mejorar?",
    "category": "Categoría",
    "selectCategory": "Selecciona una categoría",
    "categories": {
      "accuracy": "Precisión",
      "helpfulness": "Utilidad",
      "responseSpeed": "Velocidad de respuesta",
      "clarity": "Claridad",
      "other": "Otro"
    },
    "comments": "Comentarios",
    "placeholder": "Cuéntanos más sobre tu experiencia...",
    "cancel": "Cancelar",
    "submit": "Enviar opinión",
    "submitting": "Enviando..."
  },
  "auth": {
    "limitReached": "Límite diario alcanzado",
    "signUpToday": "Regístrate para más mensajes",
    "limitMessage": "Has alcanzado tu límite diario de mensajes. Regístrate con una cuenta gratuita para continuar chateando.",
    "benefitsMessage": "Crea una cuenta gratuita para seguir chateando y guardar tu historial de chat en todos tus dispositivos.",
    "remainingMessages": "Te quedan {count} mensajes hoy",
    "signUp": "Registrarse",
    "login": "Iniciar sesión",
    "loggedInAs": "Conectado como {email}",
    "logout": "Cerrar sesión"
  }
}
